(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.Grip = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Grip = function (_React$Component) {
    _inherits(Grip, _React$Component);

    function Grip() {
      _classCallCheck(this, Grip);

      return _possibleConstructorReturn(this, (Grip.__proto__ || Object.getPrototypeOf(Grip)).apply(this, arguments));
    }

    _createClass(Grip, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          {
            className: 'hidden-lg',
            style: {
              display: 'inline-block',
              marginLeft: '5px',
              float: 'right'
            }
          },
          _react2.default.createElement(
            'a',
            {
              onClick: this.props.toggleMenu,
              className: 'menu-toggle-grip',
              style: {
                display: 'block',
                height: '75px',
                padding: '25px 5px',
                fontSize: '16px',
                color: '#fff',
                textDecoration: 'none',
                cursor: 'pointer'
              }
            },
            _react2.default.createElement(
              'span',
              {
                style: {
                  width: '30px',
                  display: 'inline-block',
                  marginTop: '3px'
                }
              },
              _react2.default.createElement('img', {
                className: 'pull-right',
                src: this.props.open ? 'https://www.concur.com/sites/all/modules/custom_concur/concur_responsive_menu/images/mob-ico-close.png' : 'https://www.concur.com/sites/all/modules/custom_concur/concur_responsive_menu/images/mob-ico-ham.png'
              })
            )
          )
        );
      }
    }]);

    return Grip;
  }(_react2.default.Component);

  exports.default = Grip;


  Grip.propTypes = {
    dropdownLabel: _propTypes2.default.string,
    open: _propTypes2.default.bool,
    toggleMenu: _propTypes2.default.func
  };

  Grip.defaultProps = {
    dropdownLabel: 'MENU'
  };
});